import React from 'react';
import compose from 'recompose/compose';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';

import AppBar from '@material-ui/core/AppBar';
import Paper from '@material-ui/core/Paper';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Badge from '@material-ui/core/Badge';


import FormGroup from "@material-ui/core/FormGroup";
import TextField from "@material-ui/core/TextField";
import Checkbox from "@material-ui/core/Checkbox";
import Switch from '@material-ui/core/Switch';
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Divider from '@material-ui/core/Divider';
import {connect} from "react-redux";
import {getValueHash, isObjectEquals} from "../../../../common/utils/array";
import moment from "moment";
import {isHankaku} from "../../../../common/utils/validation";


const styles = theme => ({
	root: {
		width: '100%',
		flexGrow: 1,
		backgroundColor: theme.palette.background.paper,
	},
	formGroups:{
		paddingTop: 5,
		alignItems:'start'
	},
	halfTextArea:{
		flexBasis:2,
		flexGrow: 2
	},
	quadTextArea:{
		flexBasis:1,
		flexGrow: 1
	},
	halfDivider:{
		width:30
	},
	checkBoxWrapper:{
		paddingTop:10
	},
	divider:{
		marginTop:15,
		marginBottom:15
	},
	ExpansionPanelDetailsRowTitle:{
		color:'rgba(0,0,0,0.54)',
		paddingRight:20,
		paddingTop:12
	},
	ExpansionPanelDetailsRowTitleSecond:{
		borderLeft:'rgba(0,0,0,0.3) solid 1px',
		paddingLeft:20,
		paddingTop:12

	},
	electronicGroups:{
		border:'solid 1px rgba(0,0,0,0.12)',
		borderRadius:5,
		padding:'10px 20px',
		marginTop: -25,
		position:'relative',
		zIndex:1

	},
	electronicGroupsHidden:{
		backgroundColor:'#FFFFFF'
	},
	selectHelperText:{
		color:"#F44336",
		fontSize:'0.75rem',
		marginTop:8,
		minHeight:'1em',
		fontFamily:'"Roboto", "Helvetica", "Arial", sans-serif',
		lineHeight:'1em'
	},
	errorText:{
		color:"#F44336"
	},
	padding: {
		padding: `0 ${theme.spacing.unit * 2}px`,
	},
	withSelectTextAdjustment:{
		marginTop:4
	}
});

const flg = [
	1<<0
,	1<<1
,	1<<2
,	1<<3
];

const requireField = [
	"KeiyakuKigyouName1",
];

const numberField = [
	"KaishuSite",
	"KaishuYoteibi",
	"TegataSite",
	"GinkoCD",
	"ShitenNO",
	"KozaNO",
	"YoshinGendogaku",
]

const tab1_contents = [
	"KeiyakuKigyouName1",
	"KeiyakuKigyouName2",
	"Furigana",
	"Ryakushou",
	"KeiyakuDaihyoushaName",
	"Keishou",
	"ZipCD",
	"Address1",
	"Address2",
	"Address3",
	"TatemonoName",
	"Tel1",
	"Tel2",
	"Tel3",
	"Fax",
	"MailAddress",
	"URL",
	"JigyoushaShubetsu",
	"KeiyakuKbn",
	"TorihikiKaishiYMD",
	"TorihikiShuryouYMD",
	"Biko1",
	"Biko2",
	"Biko3",
	"Biko4",
]

const tab3_contents = [
	"APIRenkeiFlag",
	"APIRenkeiPassword",
	"ElectronicReceiptFlg",
]


function TabContainer(props) {
	return (
		<Paper square style={{padding:20}}>
			{props.children}
		</Paper>
	);
}


class innerForm extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			selectedTab:0,
			dataSource:getValueHash(props.dataSource),
			errors:{}
		}
	}

	UNSAFE_componentWillReceiveProps(nextProps){
		if(!isObjectEquals(this.state.dataSource,nextProps.dataSource)){
			this.setState({
				dataSource : getValueHash(nextProps.dataSource)
			});
		}
		if(this.props.isAddConditions === false && nextProps.isAddConditions === true){
			const errors = this.errorChecks(nextProps.dataSource,null, nextProps.isAddConditions);
			this.setState({
				dataSource : getValueHash(nextProps.dataSource),
				errors
			});
			if(nextProps.afterChangeFunc) nextProps.afterChangeFunc(getValueHash(nextProps.dataSource),errors);
		}
		if(nextProps.isClear){
			this.setState({
				errors:{},
				selectedTab:0,
			});
		}
	}

	handleChangeTabs = (event,selectedTab) =>{
		this.setState({selectedTab});
	}


	setValues = (key, data) =>{
		if(Object.prototype.toString.call(data) !== '[object Object]') return "";
		if(!(key in data)) return "";
		if(data[key] === null) return "";

		return String(data[key]);
	}
	setDateValues = (key,data) =>{
		if(Object.prototype.toString.call(data) !== '[object Object]') return null;
		if(!(key in data)) return null;
		if(data[key] === null) return null;
		return new moment(data[key]);

	}

	handleChangeText = (event) =>{
		let {dataSource} = this.state;
		dataSource[event.target.name] = event.target.value;
		const errors = this.errorChecks(dataSource,event.target.name,this.props.isAddConditions);
		this.setState({
			dataSource,
			errors
		});
		if(this.props.afterChangeFunc) this.props.afterChangeFunc(dataSource,errors);
	}


	handleChangeCheck = (event,value) =>{
		let {dataSource} = this.state;
		switch(event.target.name){
			case "JigyoushaShubetsu":
				dataSource[event.target.name] ^= flg[parseInt(event.target.value,10)];
				break;
			default:
				if(value){
					dataSource[event.target.name] = "1";
				}
				else{
					dataSource[event.target.name] = "0";
				}

		}
		const errors = this.errorChecks(dataSource,event.target.name,this.props.isAddConditions);
		this.setState({
			dataSource,
			errors
		});
		if(this.props.afterChangeFunc) this.props.afterChangeFunc(dataSource,errors);
	}

	handleChangeSelect = (value,name) =>{
		let {dataSource} = this.state;
		if(value){
			dataSource[name] = value.value;
		}
		else{
			dataSource[name] = null;
		}
		const errors = this.errorChecks(dataSource,name,this.props.isAddConditions);
		this.setState({
			dataSource,
			errors
		});
		if(this.props.afterChangeFunc) this.props.afterChangeFunc(dataSource,errors);
	}

	handleChangeRadio = (event,value) =>{
		let {dataSource} = this.state;
		dataSource[event.target.name] = value;
		const errors = this.errorChecks(dataSource,event.target.name,this.props.isAddConditions);
		this.setState({
			dataSource,
			errors
		});
		if(this.props.afterChangeFunc) this.props.afterChangeFunc(dataSource,errors);
	}

	handleChangeDate = (name,value) =>{
		let {dataSource, errors} = this.state;
		dataSource[name] = moment(value).format('YYYY-MM-DD')
		if (name in errors) delete errors[name];
		this.setState({
			dataSource,
			errors
		});
		if(this.props.afterChangeFunc) this.props.afterChangeFunc(dataSource,errors);

	};

	handleChangeDateInput = (name,e)=>{
		let {dataSource, errors} = this.state;
		dataSource[name] = null;
		if(e.target.value){
			errors[name] = "エラー";
		}
		this.setState({
			dataSource,
			errors
		});
		if(this.props.afterChangeFunc) this.props.afterChangeFunc(dataSource,errors);
	}


	isError = (key, errors) =>{
		return Boolean(key in errors && errors[key]);
	}
	getErrorText = (key,errors)=>{
		if(!(key in errors)) return "";
		if(errors[key] === null || errors[key] === "null" || errors[key] === undefined) return "";
		return errors[key];
	}

	errorChecks = (data,key,isAddConditions) =>{
		let checkColumn = [];
		if(key === undefined || key === null){
			Object.keys(data).forEach((column)=>{
				checkColumn.push(column);
			});
		}
		else{
			checkColumn.push(key);
		}
		let errors = getValueHash(this.state.errors);
		checkColumn.forEach((column)=>{
			if(column in errors) delete errors[column];
			switch(column){
				case "JigyoushaShubetsu":
					if(this.setValues(column,data) === "0"){
						errors[column] = "1つ以上選択"
					}
					if((this.setValues(column,data) & flg[2]) === flg[2] &&
					this.setValues("ReceiverPaperLogicTokens",data) === ""){
						errors["ReceiverPaperLogicTokens"] = "必須入力"
					}
					else{
						if("ReceiverPaperLogicTokens" in errors) delete errors["ReceiverPaperLogicTokens"];
					}
					break;
				case "APIRenkeiFlag":
				case "APIRenkeiPassword":
					if("APIRenkeiPassword" in errors) delete errors["APIRenkeiPassword"];
					if(this.setValues("APIRenkeiFlag",data) === "1" &&
						this.setValues("APIRenkeiPassword",data) === "" &&
						isAddConditions
					){
						errors["APIRenkeiPassword"] = "必須入力"
					}
					else if(this.setValues("APIRenkeiFlag",data) === "1" &&
						!isHankaku(this.setValues("APIRenkeiPassword",data))){
						errors["APIRenkeiPassword"] = "半角英数記号で入力"
					}
					break;
				default:
					//requireCheck
					if(requireField.indexOf(column) >= 0 && this.setValues(column,data) === ""){
						errors[column] = "必須入力"
					}

					if(numberField.indexOf(column) >= 0 && isNaN(this.setValues(column,data))){
						errors[column] = "数値で入力"
					}
			}
		});

		return errors;
	}



	render () {
		const {classes, allDisabled} = this.props;
		const {selectedTab, dataSource, errors} = this.state;


		const APIRenkeiFlag = (this.setValues("APIRenkeiFlag", dataSource) === "1");
		const APIPassDisabled = allDisabled || !APIRenkeiFlag;

		const ElectronicReceiptFlg = (this.setValues("ElectronicReceiptFlg", dataSource) === "1");
		const EcosystemUseFlg = (this.setValues("EcosystemUseFlg", dataSource) === "1");

		const JigyoushaShubetsuMaker = (this.setValues("JigyoushaShubetsu", dataSource) & flg[0]) === flg[0];
		const JigyoushaShubetsuNohinJigyousha = (this.setValues("JigyoushaShubetsu", dataSource) & flg[1]) === flg[1];
		const JigyoushaShubetsu3PL = (this.setValues("JigyoushaShubetsu", dataSource) & flg[3]) === flg[3];


		let tab1_error_count = 0;
		let tab3_error_count = 0;
		Object.keys(errors).forEach((column) => {
			if (tab1_contents.indexOf(column) !== -1) tab1_error_count++;
			if (tab3_contents.indexOf(column) !== -1) tab3_error_count++;
		});

		return (
			<div className={classes.root}>
				<AppBar position="static">
					<Tabs
						value={selectedTab}
						onChange={this.handleChangeTabs}
					>
						<Tab label={
							tab1_error_count === 0 ? "基本設定" :
								<Badge className={classes.padding} color="error" badgeContent={tab1_error_count}>
									基本設定
								</Badge>
						}/>
						<Tab label={
							tab3_error_count === 0 ? "オプション" :
								<Badge className={classes.padding} color="error" badgeContent={tab3_error_count}>
									オプション
								</Badge>
						} />
					</Tabs>
				</AppBar>
				{selectedTab === 0 &&
				<TabContainer>
					<FormGroup row className={classes.formGroups}>
						<TextField
							label="企業名称1"
							placeholder="企業名称1"
							value={this.setValues("KeiyakuKigyouName1",dataSource)}
							className={classes.halfTextArea}
							onChange={this.handleChangeText}
							disabled={allDisabled}
							name="KeiyakuKigyouName1"
							error={this.isError("KeiyakuKigyouName1",errors)}
							helperText={this.getErrorText("KeiyakuKigyouName1",errors)}
							inputProps={{
								maxLength:40
							}}
						/>
						<div className={classes.halfDivider} />
						<TextField
							label="企業名称2"
							placeholder="企業名称2"
							value={this.setValues("KeiyakuKigyouName2",dataSource)}
							className={classes.halfTextArea}
							onChange={this.handleChangeText}
							disabled={allDisabled}
							name="KeiyakuKigyouName2"
							error={this.isError("KeiyakuKigyouName2",errors)}
							helperText={this.getErrorText("KeiyakuKigyouName2",errors)}
							inputProps={{
								maxLength:40
							}}
						/>
					</FormGroup>
					<FormGroup row className={classes.formGroups}>
						<TextField
							label="フリガナ"
							placeholder="フリガナ"
							value={this.setValues("Furigana",dataSource)}
							className={classes.halfTextArea}
							onChange={this.handleChangeText}
							disabled={allDisabled}
							name="Furigana"
							error={this.isError("Furigana",errors)}
							helperText={this.getErrorText("Furigana",errors)}
							inputProps={{
								maxLength:40
							}}
						/>
						<div className={classes.halfDivider} />
						<div className={classes.halfDivider} />
						<TextField
							label="TEL"
							placeholder="TEL"
							value={this.setValues("Tel1",dataSource)}
							className={classes.quadTextArea}
							onChange={this.handleChangeText}
							disabled={allDisabled}
							name="Tel1"
							error={this.isError("Tel1",errors)}
							helperText={this.getErrorText("Tel1",errors)}
							inputProps={{
								maxLength:16
							}}
						/>
						<div className={classes.halfDivider} />
						<div className={classes.quadTextArea} />
					</FormGroup>
					<Divider className={classes.divider} />
					<FormGroup row className={classes.formGroups}>
						<TextField
							label="住所"
							placeholder="住所"
							value={this.setValues("Address1",dataSource)}
							className={classes.halfTextArea}
							onChange={this.handleChangeText}
							disabled={allDisabled}
							name="Address1"
							error={this.isError("Address1",errors)}
							helperText={this.getErrorText("Address1",errors)}
							inputProps={{
								maxLength:40
							}}
						/>
					</FormGroup>
					<Divider className={classes.divider} />
					<FormGroup row className={classes.formGroups}>
						<div className={classNames(classes.ExpansionPanelDetailsRowTitle,this.isError("JigyoushaShubetsu", errors) ? classes.errorText : "")}>
							業種
						</div>
						<FormControlLabel
							control={
								<Checkbox
									checked={JigyoushaShubetsuMaker}
									onChange={this.handleChangeCheck}
									color="primary"
									disabled={allDisabled}
									value={"0"}
									name={"JigyoushaShubetsu"}
								/>
							}
							label="メーカー"
						/>
						<FormControlLabel
							control={
								<Checkbox
									checked={JigyoushaShubetsuNohinJigyousha}
									onChange={this.handleChangeCheck}
									disabled={allDisabled}
									color="primary"
									value={"1"}
									name={"JigyoushaShubetsu"}
								/>
							}
							label="納品事業者"
						/>
						<FormControlLabel
							control={
								<Checkbox
									checked={JigyoushaShubetsu3PL}
									onChange={this.handleChangeCheck}
									disabled={allDisabled}
									color="primary"
									value={"3"}
									name={"JigyoushaShubetsu"}
								/>
							}
							label="3PL"
						/>
					</FormGroup>
					<Divider className={classes.divider} />
					<FormGroup row className={classes.formGroups}>
						<TextField
							label="備考1"
							placeholder="備考1"
							value={this.setValues("Biko1",dataSource)}
							className={classes.halfTextArea}
							onChange={this.handleChangeText}
							disabled={allDisabled}
							name="Biko1"
							error={this.isError("Biko1",errors)}
							helperText={this.getErrorText("Biko1",errors)}
							inputProps={{
								maxLength:60
							}}
						/>
					</FormGroup>
					<FormGroup row className={classes.formGroups}>
						<TextField
							label="備考2"
							placeholder="備考2"
							value={this.setValues("Biko2",dataSource)}
							className={classes.halfTextArea}
							onChange={this.handleChangeText}
							disabled={allDisabled}
							name="Biko2"
							error={this.isError("Biko2",errors)}
							helperText={this.getErrorText("Biko2",errors)}
							inputProps={{
								maxLength:60
							}}
						/>
					</FormGroup>
					<FormGroup row className={classes.formGroups}>
						<TextField
							label="備考3"
							placeholder="備考3"
							value={this.setValues("Biko3",dataSource)}
							className={classes.halfTextArea}
							onChange={this.handleChangeText}
							disabled={allDisabled}
							name="Biko3"
							error={this.isError("Biko3",errors)}
							helperText={this.getErrorText("Biko3",errors)}
							inputProps={{
								maxLength:60
							}}
						/>
					</FormGroup>
					<FormGroup row className={classes.formGroups}>
						<TextField
							label="備考4"
							placeholder="備考4"
							value={this.setValues("Biko4",dataSource)}
							className={classes.halfTextArea}
							onChange={this.handleChangeText}
							disabled={allDisabled}
							name="Biko4"
							error={this.isError("Biko4",errors)}
							helperText={this.getErrorText("Biko4",errors)}
							inputProps={{
								maxLength:60
							}}
						/>
					</FormGroup>
				</TabContainer>
				}
				{selectedTab === 1 &&
				<TabContainer>
					<FormGroup row className={classes.formGroups}>
						<div className={classes.ExpansionPanelDetailsRowTitle}>
							API連携
						</div>
						<FormControlLabel
							control={
								<Switch
									checked={APIRenkeiFlag}
									onChange={this.handleChangeCheck}
									disabled={allDisabled}
									color="primary"
									value={"1"}
									name={"APIRenkeiFlag"}
								/>
							}
							label="API連携を使用する"
						/>
						<div className={classes.halfTextArea} style={{marginTop:-8,display:'flex'}}>
							<TextField
								label="API連携パスワード"
								placeholder="API連携パスワード"
								value={this.setValues("APIRenkeiPassword",dataSource)}
								onChange={this.handleChangeText}
								className={classes.halfTextArea}
								disabled={APIPassDisabled}
								name="APIRenkeiPassword"
								error={this.isError("APIRenkeiPassword",errors)}
								helperText={this.getErrorText("APIRenkeiPassword",errors)}
								inputProps={{
									maxLength:20
								}}
							/>
						</div>
					</FormGroup>
					<FormGroup row className={classes.formGroups}>
						<div style={{color:'rgba(0,0,0,0.67)'}} className={classes.halfTextArea}>※パスワードエリアはパスワードの変更が必要な場合のみ入力してください</div>
					</FormGroup>
					<Divider className={classes.divider} />
					<FormGroup row className={classes.formGroups}>
						<div className={classes.ExpansionPanelDetailsRowTitle}>
							電子受領
						</div>
						<FormControlLabel
							control={
								<Switch
									checked={ElectronicReceiptFlg}
									onChange={this.handleChangeCheck}
									disabled={allDisabled}
									color="primary"
									value={"1"}
									name={"ElectronicReceiptFlg"}
								/>
							}
							label="電子受領を使用する"
						/>
					</FormGroup>
					<Divider className={classes.divider} />
					<FormGroup row className={classes.formGroups}>
						<div className={classes.ExpansionPanelDetailsRowTitle}>
							エコシステム連携
						</div>
						<FormControlLabel
							control={
								<Switch
									checked={EcosystemUseFlg}
									onChange={this.handleChangeCheck}
									disabled={allDisabled}
									color="primary"
									value={"1"}
									name={"EcosystemUseFlg"}
								/>
							}
							label="エコシステム連携を利用する"
						/>
					</FormGroup>
				</TabContainer>
				}
			</div>
		);
	}
}
innerForm.propTypes = {
	dataSource:PropTypes.object,
	allDisabled:PropTypes.bool,
	afterChangeFunc:PropTypes.func,
	isAddConditions:PropTypes.bool,
	isClear:PropTypes.bool
};
innerForm.defaultProps = {
	dataSource:{},
	allDisabled:true,
	isAddConditions:false,
	isClear:false
}

function mapStateToProps(state) {
	return {
		navigation : state.navigation,
		auth: state.auth,
		settings : state.masterKeiyakuKigyouSettings,
	};
}
export default compose(
	withStyles(styles),
	connect(mapStateToProps)
)(innerForm);



// WEBPACK FOOTER //
// ./src/routes/master/keiyaku-kigyou/components/inner-form.js